import { Component } from '@angular/core';

@Component({
    selector: 'app-redirect',
    imports: [],
    template: '',
    styles: ''
})
export class RedirectComponent {

}
